<template>
    <div class="h-full">
        <Head :title="__(title)"/>
        <board-view-menu :project="project" view="workload"/>
        <div class="flex flex-col task__dashboard px-4 py-4 gap-4 h-[calc(100%-52px)] overflow-hidden overflow-y-auto">
            <div class="flex gap-5 flex-col lg:flex-row w-full float-right">
                <div class="w-full bg-white rounded-lg shadow-lg p-10">
                    <div>
                        <multi-select-input class="pb-4 mb-4 pr-6 w-full lg:w-1/4 float-right"
                                            style="background-color: whitesmoke"
                                            :label="__('Select Employee')"
                                            :users="users"
                                            v-model="selectedUsers"
                                            :options="userOptions"
                                            @update:selectedUsers="updateSelectedUsers"
                                            label="Select Users"
                        />
                        <GanttChart :options="options" :tasks="filteredTasks"/>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import GanttChart from './GanttChart'
import Layout from '@/Shared/Layout'
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import BoardViewMenu from '@/Shared/BoardViewMenu'
import MultiSelectInput from '@/Shared/MultiSelectInput'
import dayjs from 'dayjs'

export default {
    components: {
        GanttChart,
        Head,
        Icon,
        Link,
        BoardViewMenu,
        MultiSelectInput,
    },
    layout: Layout,
    props: {
        title: String,
        auth: Object,
        project: Object,
        users: Array,
        tasks: Array,
        /* per_list: Object,
         per_assignee: Object,
         per_label: Object,
         due_data: {
             required: true,
         },*/
    },
    data() {
        return {
            selectedUsers: [],
            users: [],
            newTasks: [],
            temp: [],
            options: {
                title: {
                    label: 'Your project title as html (link or whatever...)',
                    html: false,
                },
                taskList: {
                    columns: [
                        {
                            id: 1,
                            label: 'ID',
                            value: 'id',
                            width: 40,
                        },
                        {
                            id: 2,
                            label: 'Description',
                            value: 'description',
                            width: 200,
                            expander: true,
                        },
                        {
                            id: 3,
                            label: 'Assigned to',
                            value: 'assigneeNames',
                            width: 130,
                            html: true,
                        },
                        {
                            id: 4,
                            label: 'Start',
                            value: task => dayjs(task.start).format('YYYY-MM-DD'),
                            width: 78,
                        },
                        {
                            id: 4,
                            label: 'due date',
                            value: task => dayjs(task.due_date).format('YYYY-MM-DD'),
                            width: 78,
                        },
                        {
                            id: 5,
                            label: '%',
                            value: 'progress',
                            width: 35,
                            style: {
                                'task-list-header-label': {
                                    'text-align': 'center',
                                    width: '100%',
                                },
                                'task-list-item-value-container': {
                                    'text-align': 'center',
                                },
                            },
                        },

                    ],
                },
            },
        }
    },
    methods: {
        getDate(hours) {
            const currentDate = new Date()
            const currentYear = currentDate.getFullYear()
            const currentMonth = currentDate.getMonth() + 1
            const currentDay = currentDate.getDate()
            const timeStamp = new Date(`${currentYear}-${currentMonth}-${currentDay} 00:00:00`).getTime()
            return new Date(timeStamp + hours * 60 * 60 * 1000).getTime()

        },
        calculateDuration(start, end) {
            const startDate = new Date(`${start}T00:00:00`).getTime()
            const dueDate = new Date(`${end}T00:00:00`).getTime()
            // Calculate duration in milliseconds
            const duration = dueDate - startDate
            // Validate: If duration is negative, return 0
            return duration > 0 ? duration : 0
        },
        calculateProgress(startDate, endDate) {
            // Convert start and end dates to JavaScript Date objects
            const start = new Date(startDate)
            const end = new Date(endDate)
            const currentDate = new Date()

            // Ensure current date is not after the end date
            if (currentDate > end) {
                return 100 // If the current date is beyond the end date, return 100% progress
            }

            // Calculate the total duration in milliseconds (from start to end)
            const totalDuration = end - start

            // Calculate the elapsed time in milliseconds (from start to current date)
            const elapsedTime = currentDate - start

            // Calculate progress percentage
            let progress = (elapsedTime / totalDuration) * 100

            // Ensure progress does not exceed 100% or fall below 0%
            progress = Math.round(Math.min(Math.max(progress, 0), 100))

            return progress
        },
        removeHtmlTags(description) {
            // Remove all HTML tags
            if (description != null) {
                return description.replace(/<[^>]*>/g, '')
            }
        },
        updateSelectedUsers(users) {
            // Update the selected users when the child emits the event
            this.selectedUsers = users;
        },
    },
    mounted() {
        this.temp.push(this.project.workspace.member_list)
        this.temp.forEach(userArray => {
            // Check if each userArray is an array and push its user objects
            if (Array.isArray(userArray)) {
                this.users.push(...userArray.map(userObject => userObject.user))  // Extract user objects
            }
        })
    },
    computed: {
        transformedTasks() {
            return this.tasks.map(task => ({
                id: task.id,
                title: task.title,
                assignees: task.assignees.map(assignee => ({
                    id: assignee.id,
                    task_id: assignee.task_id,
                    user_id: assignee.user_id,
                    name: assignee.user.name,
                })),
                assigneeNames: task.assignees.map(a => a.user.name).join(', '),
                description: this.removeHtmlTags(task.description),
                type: 'task',
                duration: this.calculateDuration(dayjs(task.created_at).format('YYYY-MM-DD'), dayjs(task.due_date).format('YYYY-MM-DD')),
                start: task.created_at,
                progress: this.calculateProgress(dayjs(task.created_at).format('YYYY-MM-DD'), dayjs(task.due_date).format('YYYY-MM-DD')),
                due_date: task.due_date,
                style: {
                    base: {
                        fill: '#39A050FF',
                        stroke: '#0077C0',
                    },
                },
            }))
        },
        filteredTasks() {
            // If no users are selected, return all tasks
            this.selectedUsers.map( a => a.id)
            if (this.selectedUsers.length === 0) {
                return this.transformedTasks
            }
            const selectedUserIds = this.selectedUsers.map(user => user.id);
            // Filter tasks where any assignee's user_id matches a selected user ID
            return this.transformedTasks.filter(task =>
                task.assignees.some(assignee => selectedUserIds.includes(assignee.user_id))

            )
        },
    },
}
</script>
